// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------
import { createEnum } from "@cartographerio/util";
const VegetationCover = "VegetationCover";
const InfiltrationEnhancement = "InfiltrationEnhancement";
const AttenuationOfRunoff = "AttenuationOfRunoff";
const AttenuationOfChannelFlow = "AttenuationOfChannelFlow";
const ChannelFloodplainConnectivity = "ChannelFloodplainConnectivity";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const EcostatusNfmCategoryEnum = {
    ...createEnum("EcostatusNfmCategory", [
        [VegetationCover, "Vegetation cover"],
        [InfiltrationEnhancement, "Infiltration enhancement"],
        [AttenuationOfRunoff, "Attenuation of runoff"],
        [AttenuationOfChannelFlow, "Attenuation of channel flow"],
        [ChannelFloodplainConnectivity, "Channel-floodplain connectivity"],
    ]),
    VegetationCover,
    InfiltrationEnhancement,
    AttenuationOfRunoff,
    AttenuationOfChannelFlow,
    ChannelFloodplainConnectivity,
};
null;
null;
export default EcostatusNfmCategoryEnum;
//# sourceMappingURL=EcostatusNfmCategoryEnum.generated.js.map